import { render, staticRenderFns } from "./ExtraFieldQuickEdit.vue?vue&type=template&id=9203be50"
import script from "./ExtraFieldQuickEdit.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldQuickEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9203be50')) {
      api.createRecord('9203be50', component.options)
    } else {
      api.reload('9203be50', component.options)
    }
    module.hot.accept("./ExtraFieldQuickEdit.vue?vue&type=template&id=9203be50", function () {
      api.rerender('9203be50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/ExtraFieldQuickEdit.vue"
export default component.exports